import axios from 'axios';
import type {
  IContactChangeOwnerRequest,
  IContactChangeOwnerResponse,
} from '@bb/contacts';

const changeOwner = async (contactId: string, userId: string) => {
  const config: IContactChangeOwnerRequest = {
    url: `contacts/${contactId}/owner`,
    method: 'post',
    data: { userId },
  };
  const { data } = await axios.request<IContactChangeOwnerResponse>(config);

  return data;
};

export default changeOwner;
